import { render, staticRenderFns } from "./TechnicalExpert.vue?vue&type=template&id=264d5458&scoped=true&"
import script from "./TechnicalExpert.vue?vue&type=script&lang=js&"
export * from "./TechnicalExpert.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalExpert.vue?vue&type=style&index=0&id=264d5458&lang=scss&scoped=true&"
import style1 from "./TechnicalExpert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d5458",
  null
  
)

export default component.exports